export const SIGN_UP = `
  mutation signUp($firstName: String!, $lastName: String!, $email: AWSEmail!, $password: String!, $preferredName: String, $locale: String, $grade: String, $school: String) {
    signUp(firstName: $firstName, lastName: $lastName, email: $email, password: $password, preferredName: $preferredName, locale: $locale, grade: $grade, school: $school)
  }
`;
